import React, { useState, useEffect } from "react";
import { Calendar, RotateCcw, CheckCircle2 } from "lucide-react";

const DateRangeFilter = ({ 
  currentStartDate, 
  currentEndDate, 
  onApply, 
  onClear 
}) => {
  const [localStart, setLocalStart] = useState(currentStartDate || "");
  const [localEnd, setLocalEnd] = useState(currentEndDate || "");

  useEffect(() => {
    setLocalStart(currentStartDate || "");
    setLocalEnd(currentEndDate || "");
  }, [currentStartDate, currentEndDate]);

  return (
    <div className="w-full bg-white dark:bg-slate-900 border border-stone-200 dark:border-white/10 rounded-2xl p-2 shadow-sm">
      {/* 
          grid-cols-1: Default full width di mobile (otomatis stack)
          md:grid-cols-12: Aktif di layar medium ke atas untuk pembagian 8:4
      */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-center">
        
        {/* AREA TEXTBOX (Jatah 8 Kolom) */}
        <div className="md:col-span-8 flex flex-col sm:flex-row items-center gap-3 bg-stone-50/50 dark:bg-slate-800/30 p-2 rounded-xl border border-stone-100 dark:border-white/5">
          <div className="relative flex-1 w-full">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Calendar size={14} className="text-blue-600" />
            </div>
            <input 
              type="date" 
              value={localStart}
              onChange={(e) => setLocalStart(e.target.value)}
              className="w-full pl-9 pr-3 py-2 bg-white dark:bg-slate-950 border border-stone-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none focus:ring-2 focus:ring-blue-500/20"
            />
          </div>

          <span className="text-[10px] font-black text-stone-400 uppercase">To</span>

          <div className="relative flex-1 w-full">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Calendar size={14} className="text-blue-600" />
            </div>
            <input 
              type="date" 
              value={localEnd}
              onChange={(e) => setLocalEnd(e.target.value)}
              className="w-full pl-9 pr-3 py-2 bg-white dark:bg-slate-950 border border-stone-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none focus:ring-2 focus:ring-blue-500/20"
            />
          </div>
        </div>

        {/* AREA BUTTON (Jatah 4 Kolom - Full width kalau turun) */}
        <div className="md:col-span-4 flex gap-2 w-full">
          <button 
            onClick={() => onApply(localStart, localEnd)}
            className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-[10px] font-black uppercase tracking-tighter transition-all active:scale-95 shadow-md shadow-blue-600/20"
          >
            <CheckCircle2 size={14} /> Apply
          </button>

          <button 
            onClick={() => { setLocalStart(""); setLocalEnd(""); onClear(); }}
            className="p-2.5 bg-stone-100 dark:bg-white/5 text-stone-400 hover:text-red-600 rounded-xl transition-all flex items-center justify-center"
            title="Reset"
          >
            <RotateCcw size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;